import { postRequest } from '@/core';
import { edi } from '@/requests';
export default async function(edipartData) {
	let url = edi.createNewEdipart();
	let response = await postRequest(url, '', edipartData);
	return response;
}